import React from 'react';
import { useTranslation } from 'react-i18next';
import BookHeader from '../../../components/BookHeader';
import Guidance from '../../../../../components/Guidance';
import BookLogHistory from './BookLogHistory';
import Reading from './Reading';
import Completed from './Completed';
import { BOOK_STATUS } from '../../../../../services/constants';
import { useLocation } from 'react-use';
import cx from 'classnames';
import styles from './BookHolder.module.scss';
import reviewStar from '../../../../../images/new-star-filled.png';

const BookHolder = ({ studentBook }) => {

    const location = useLocation();

    const { t } = useTranslation();
    const guidance = {
        started: t('reading_log_instructions'),
        completed: t('review_time_instructions'),
        reviewed: t('review_submitted_instructions')
    };

    const renderContent = () => {
        switch(studentBook.status) {
            case BOOK_STATUS.new:
            case BOOK_STATUS.started:
                return {book: <Reading studentBook={studentBook} />, info: guidance.started}
            case BOOK_STATUS.completed:
                return {book: <Completed studentBook={studentBook} />, info: studentBook.book.myReview ? guidance.reviewed : guidance.completed}
            default:
                return {book: 'Nothing here', info: '-'}
        }
    }

    const content = renderContent();
    const isReviewPage = studentBook.status === BOOK_STATUS.completed && !studentBook.book.myReview;
    const isReviewedPage = studentBook.status === BOOK_STATUS.completed && !!studentBook.book.myReview;
    const showReviewGuidance = isReviewPage || isReviewedPage;

    return(
        <div className={styles.bookPage}>
            <div className={cx('page-wrapper', styles.bookPageRow)}>
                <div className="page-wrapper__main">
                    <div className={cx('content-panel', styles.bookPanel)}>
                        <BookHeader studentBook={studentBook} />
                    </div>
                </div>
            </div>

            <div className={cx('page-wrapper', styles.bookPageRow)}>
                <div className={cx('page-wrapper__main', styles.bookFormMain)}>
                    <div className={cx('content-panel', styles.bookPanel, {
                        [styles.reviewedPanel]: isReviewedPage
                    })}>
                        {location?.state?.book_readded && <p className='u-mb-3 heavy'>Book readded successfully!</p>}
                        {content.book}
                    </div>
                    {!isReviewedPage && (
                        <div className={cx('content-panel', styles.bookPanel, styles.bookStackedPanel)}>
                            <BookLogHistory logs={studentBook.logs} />
                        </div>
                    )}
                </div>
                <div className={cx('page-wrapper__side', styles.guidanceColumn)}>
                    <Guidance
                        headingImage={showReviewGuidance ? reviewStar : undefined}
                        reviewPage={showReviewGuidance}
                        text={content.info}
                        title={showReviewGuidance ? 'review_time' : 'Instructions'}
                        readingPage
                    />
                </div>
            </div>
        </div>
    )
}

export default BookHolder
